import * as React from 'react'

import {
  TQPaymentLockedOrderVariables,
  useQPaymentLockedOrder,
} from '~graphql/generated/clientGraphql'

type TOptions = {
  orderId: ID
}

/**
 * Loads the information about the order that is locked and has the payment in process:
 * - the branch phone.
 */
export const useLoadPaymentLockedOrder = ({ orderId }: TOptions) => {
  const variables: TQPaymentLockedOrderVariables = React.useMemo(() => {
    return {
      orderId,
    }
  }, [orderId])

  const { data } = useQPaymentLockedOrder({
    variables,
  })

  return data?.order ?? null
}
